import {connect} from "react-redux";
import ApprovalActivity from "./Action";
import {bindActionCreators} from "redux";
import {approvalActivity} from "../../../../service/FasttagToll/action";
import {viewActivity} from "../../../../service/Activity/action";

const mapStateToProps = (state) => ({
    approved: state.FasttagToll.approved,
    activityByIdDetails:state.Activity.activityByIdDetails,
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            approvalActivity,
            viewActivity
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(ApprovalActivity);
